import { render, staticRenderFns } from "./TicketAddForm.vue?vue&type=template&id=b874e4c6&scoped=true"
import script from "./TicketAddForm.vue?vue&type=script&lang=js"
export * from "./TicketAddForm.vue?vue&type=script&lang=js"
import style0 from "./TicketAddForm.vue?vue&type=style&index=0&id=b874e4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b874e4c6",
  null
  
)

export default component.exports